import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const SmsPage = lazy(() => import('./pages/SmsPage'));
const InAppChatPage = lazy(() => import('./pages/InAppChatPage'));
const VideoConferencingPage = lazy(() => import('./pages/VideoConferencingPage'));
const MessagingChannelsPage = lazy(() => import('./pages/MessagingChannelsPage'));

export const CommunicationRoutes: RouteObject = {
  path: 'communication',
  element: <ModuleGuard moduleId="core.communication" />,
  children: [
    { path: '', element: <Navigate to="in-app-chat" replace /> },
    { path: 'in-app-chat', element: <InAppChatPage />, handle: { crumb: 'In-App Chat' } },
    { path: 'video-conferencing', element: <VideoConferencingPage />, handle: { crumb: 'Video Conferencing' } },
    { path: 'sms', element: <SmsPage />, handle: { crumb: 'SMS Operations' } },
    { path: 'messaging-channels', element: <MessagingChannelsPage />, handle: { crumb: 'Messaging Channels' } },

    // Backward-compatible migration redirects to Email Domain module
    { path: 'webmail', element: <Navigate to="/core/email/webmail" replace /> },
    { path: 'email-accounts', element: <Navigate to="/core/email/accounts" replace /> },
    { path: 'email-templates', element: <Navigate to="/core/email/templates" replace /> },
    { path: 'email-logging', element: <Navigate to="/core/email/logs" replace /> },
    { path: 'shared-inbox', element: <Navigate to="/core/email/webmail" replace /> },
  ],
};
